import { Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function MapitCopyRight({
    color = "white.main",
}) {
    const { t } = useTranslation()

    return (
        <Typography
            sx={{
                color: color,
                fontSize: "16px",
                fontWeight: "400",
                lineHeight: "24px",
                wordWrap: "break-word",
                mt: '40px',
                mb: '32px',
            }}
        >
            {t("©2024 mapit. All rights reserved.")}
        </Typography>
    )
}
